import type { JSX } from 'react'

import { TextBoxMaxLine1Button2Center } from "/app/libraries/arcana/src/atoms/TextBox/Templates/index.ts"

import { useUnit } from 'effector-react'
import { translations } from '../model'

export const ForgotPasswordComponent = (): JSX.Element => {
  const formTranslations = useUnit(translations.$signInByEmailTranslations)

  return (
    <a href='/forgot-password'>
      <TextBoxMaxLine1Button2Center title={formTranslations.forgotTitle} />
    </a>
  )
}
